export enum MidiaEnum {
    Cartao = 1,
    Token = 2,
    PSC = 3,
    HSM = 4,
    Arquivo = 5,
    SemMidia = 6
}
